module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "contact"
  }, [(_vm.contactTitle) ? _c('h4', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.contactTitle))]) : _vm._e(), _vm._v(" "), (_vm.contact) ? _c('v-form', {
    ref: "contactForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.showResCheckBox) ? _c('v-checkbox', {
    attrs: {
      "label": "This is a Residential Address",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.residential),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "residential", $$v)
      },
      expression: "contactData.residential"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showUseShipping) ? _c('v-checkbox', {
    attrs: {
      "label": "Use Shipping Information for Billing"
    },
    on: {
      "change": function($event) {
        return _vm.$emit('copy-address', $event)
      }
    },
    model: {
      value: (_vm.contactData.copyAddress),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "copyAddress", $$v)
      },
      expression: "contactData.copyAddress"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "First Name",
      "rules": _vm.requiredRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.first_name),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "first_name", $$v)
      },
      expression: "contactData.first_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "rules": _vm.requiredRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.last_name),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "last_name", $$v)
      },
      expression: "contactData.last_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Company",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.company),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "company", $$v)
      },
      expression: "contactData.company"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address 1",
      "rules": _vm.requiredRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.street1),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "street1", $$v)
      },
      expression: "contactData.street1"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address 2",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.street2),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "street2", $$v)
      },
      expression: "contactData.street2"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "City",
      "rules": _vm.requiredRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.city),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "city", $$v)
      },
      expression: "contactData.city"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "State/Province",
      "placeholder": "Select if United States or Canada",
      "items": _vm.states,
      "item-value": "abbr",
      "item-text": "name",
      "dense": "",
      "clearable": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.state),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "state", $$v)
      },
      expression: "contactData.state"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "ZIP/Postal Code",
      "rules": _vm.requiredRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.zip),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "zip", $$v)
      },
      expression: "contactData.zip"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Country",
      "items": _vm.countries,
      "item-value": "abbr",
      "item-text": "name",
      "rules": _vm.requiredRules,
      "dense": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.country),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "country", $$v)
      },
      expression: "contactData.country"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email Address",
      "rules": _vm.emailRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.email),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "email", $$v)
      },
      expression: "contactData.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Phone",
      "rules": _vm.phoneRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.contactData.phone),
      callback: function($$v) {
        _vm.$set(_vm.contactData, "phone", $$v)
      },
      expression: "contactData.phone"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ee9040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/contact-input.vue
// module id = 688
// module chunks = 1